export const sequentiallyProcessPromiseFactories = <T>(
    promiseFactories: (() => Promise<T>)[]
): Promise<void> =>
    new Promise((resolve, reject) => {
        const leftToProcess = promiseFactories;
        const recursivelyProcessNext = () => {
            if (leftToProcess.length) {
                const nextAction = leftToProcess.shift();
                (nextAction() || Promise.resolve<T>(undefined))
                    .then(() => recursivelyProcessNext())
                    .catch(e => reject(e));
            } else {
                resolve();
            }
        };
        recursivelyProcessNext();
    });
